import * as dates from '@simplybenefits/sb-dates';
import * as localizationMaps from '../../../localization/maps.js';
export const initialErrorState = {
  firstnameError: false,
  lastnameError: false,
  genderError: false,
  birthdateError: false,
  emailError: false,
  relationshipError: false
};
export const initialSignageState = {
  password: '',
  passwordVisible: false,
  name: '',
  signature: '',
  datedOn: '',
  acceptedTerms: false
};
export const initialSignageErrorState = {
  passwordError: false,
  signageNameError: false,
  signatureError: false,
  signageDatedOnError: false
};

/**
 * Sets beneficiary data for the beneficiary form.
 * @param {object} beneficiaryData - Data of the beneficiary being edited or added.
 * @param {boolean} isEdit - Flag indicating if the form is in edit mode.
 * @returns {object} - Formatted beneficiary data.
 */
export const setBeneficiaryData = (beneficiaryData, isEdit) => ({
  beneficiaryID: isEdit && beneficiaryData ? beneficiaryData.beneficiaryID : null,
  firstname: isEdit && beneficiaryData ? beneficiaryData.firstname : "",
  lastname: isEdit && beneficiaryData ? beneficiaryData.lastname : "",
  relationship: isEdit && beneficiaryData ? localizationMaps.fromEnglish("relationships", beneficiaryData.relationship) : localizationMaps.fromEnglish("relationships", "Child"),
  type: isEdit && beneficiaryData ? localizationMaps.fromEnglish("beneficiariesOptions", beneficiaryData.type) : localizationMaps.fromEnglish("beneficiariesOptions", "Revocable"),
  shares: isEdit && beneficiaryData ? beneficiaryData.shares : '',
  birthdate: isEdit && beneficiaryData ? dates.formatIncomingDate(beneficiaryData.birthdate) : ''
});

/**
 * 
 * @param {\} primaryBeneficiaries 
 * @param {*} contingentBeneficiaries 
 * @returns 
 */
export const beneficiariesSharesInit = (primaryBeneficiaries, contingentBeneficiaries, selectedBeneficiaryID) => ({
  primaryBeneficiaries: primaryBeneficiaries.map(primaryBeneficiary => {
    if (primaryBeneficiary.beneficiaryID === selectedBeneficiaryID) {
      return {
        ...primaryBeneficiary
      };
    }
    return primaryBeneficiary;
  }),
  contingentBeneficiaries: contingentBeneficiaries.map(contingentBeneficiary => {
    if (contingentBeneficiary.beneficiaryID === selectedBeneficiaryID) {
      return {
        ...contingentBeneficiary
      };
    }
    return contingentBeneficiary;
  })
});